export default {"src":"/_next/static/image/public/images/flags/flag_221.5455d119f6dec40e918b217a0b6f333c.svg","height":16,"width":24};